import { render } from "./Print.svg?vue&type=template&id=e6f82258"
const script = {}
script.render = render

export default script